// A roster member is "free" to assign unless the pool (`?with_teams=1`) says it already plays for a team.
// `teams` only lists active (non-archived) teams, which is also what the server enforces with a 409.
export const memberTeamStatus = (member, teamId) => {
  const teams = Array.isArray(member?.teams) ? member.teams : [];
  if (teams.some((team) => Number(team.team_id) === Number(teamId))) {
    return { kind: "this" };
  }
  const other = teams.find((team) => Number(team.team_id) !== Number(teamId));
  if (other) {
    return { kind: "other", teamId: other.team_id, teamName: other.team_name };
  }
  return { kind: "free" };
};

export const isSelectableMember = (member, teamId) => memberTeamStatus(member, teamId).kind === "free";

export const memberFullName = (member) =>
  [member?.first_name, member?.last_name].filter(Boolean).join(" ") || `#${member?.id}`;

export const memberSecondaryLabel = (member) =>
  [member?.document_number, member?.member_number ? `#${member.member_number}` : null].filter(Boolean).join(" · ");

// Moves the checked, still-free members of the visible page into the selection (kept across pages and searches).
export const addCheckedToSelection = (selection, members, checkedIds, teamId) => {
  const taken = new Set(selection.map((entry) => String(entry.member.id)));
  const additions = members
    .filter((member) => checkedIds.includes(member.id) && isSelectableMember(member, teamId) && !taken.has(String(member.id)))
    .map((member) => ({ member, shirt_number: "" }));
  return [...selection, ...additions];
};

export const buildAssignPayload = (selection) => ({
  players: selection.map(({ member, shirt_number: shirt }) => {
    const entry = { roster_member_id: member.id };
    if (shirt !== "" && shirt != null && Number.isFinite(Number(shirt))) {
      entry.shirt_number = Number(shirt);
    }
    return entry;
  }),
});

export const conflictMemberIds = (error) =>
  error?.response?.data?.code === "player_on_another_team"
    ? (error.response.data.conflicts || []).map((conflict) => String(conflict.roster_member_id))
    : [];
